import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['alert']

  save() {
    this.alertTarget.classList.add('d-none')
    // Use native form submission instead of Rails.fire
    this.element.requestSubmit()
  }

  unsaved() {
    this.alertTarget.classList.remove('d-none')
  }
}
